import { MentorProfilePutBody, MentorProfileTrackOption } from './MentorPortalService';

const MOCK_HELPER = 'Select all tracks you can meaningfully mentor in.';
const DEC_LABEL =
    "Visible to your institute's admins. Matching currently uses your institute's pool configuration.";

type Props = {
    catalog: MentorProfileTrackOption[];
    draft: MentorProfilePutBody;
    matchingHelper: string;
    onChange: (patch: Partial<MentorProfilePutBody>) => void;
};

const MentorProfileTracks = ({ catalog, draft, matchingHelper, onChange }: Props) => {
    const selected = new Set(draft.preferredTrackIds || []);
    const truthLabel = matchingHelper || DEC_LABEL;

    const onToggle = (trackId: number) => {
        const next = selected.has(trackId)
            ? (draft.preferredTrackIds || []).filter((id) => id !== trackId)
            : [...(draft.preferredTrackIds || []), trackId];
        onChange({ preferredTrackIds: next });
    };

    return (
        <>
        

        <div className="col-lg-6 col-md-6">
                <div className="card border-0 shadow-sm rounded-3 bg-white h-100">
                  <div className="card-header bg-white border-bottom border-light-subtle p-3">
                    <h6 className="fw-bold mb-0 text-dark">Career Tracks &amp; Expertise</h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="text-secondary small font-12 mb-1">{MOCK_HELPER}</div>
                    <div className='bg-primary bg-opacity-10 p-2 border border-primary border-opacity-10 rounded-3 mb-3 font-12 text-primary-emphasis '>{truthLabel}</div>
                    <div className="d-flex flex-wrap gap-2 mb-4" id="career-tracks" role="group" aria-label="Career tracks">
                        {(catalog || []).map((track) => {
                            const isOn = selected.has(track.id);
                            return (
                                <button
                                    key={track.id}
                                    type="button"
                                    className={`badge border  py-2 px-3 font-12 cursor-pointer profile-track-tag rounded-pill font-500 ${isOn ? 'border-primary border-opacity-10 bg-primary bg-opacity-10 text-primary' : 'border-light-subtle bg-light text-secondary'}`}
                                    aria-pressed={isOn}
                                    onClick={() => onToggle(track.id)}
                                >
                                    {isOn ? <span aria-hidden="true">✓ </span> : null}
                                    {track.name || `Track ${track.id}`}
                                </button>
                            );
                        })}
                    </div>

                    <div className="mb-0">
                      <label className="form-label font-13 font-600 text-secondary text-uppercase mb-1">Specific areas I'm best at helping with</label>
                      <textarea
                            className="form-control font-13"
                            rows={3}
                            value={draft.specificAreas}
                            onChange={(event) => onChange({ specificAreas: event.target.value })}
                        />
                    </div>
                  </div>
                </div>
              </div>
        </>
        
    );
};

export default MentorProfileTracks;
